webpackJsonp([70144966829960],{

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _heroSmall = __webpack_require__(43);
	
	var _heroSmall2 = _interopRequireDefault(_heroSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultState = {
	  name: "",
	  email: "",
	  subject: "",
	  message: ""
	};
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Contact);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = defaultState, _this.onChange = function (evt) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _this$setState[evt.target.name] = evt.target.value, _this$setState));
	    }, _this.resetForm = function (evt) {
	      _this.setState(defaultState);
	    }, _this.onSubmit = function (evt) {
	      evt.preventDefault();
	      if (_this.state !== defaultState) {
	        fetch("http://webbholding.me/send-mail.php", {
	          method: "POST",
	          body: JSON.stringify(_this.state)
	        }).then(function (res) {
	          _this.resetForm();
	          alert("Message succesfully sent!");
	        }).catch(function (res) {
	          alert("Error happend. Please try again later.");
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      "main",
	      { className: "contact-page" },
	      _react2.default.createElement(_heroSmall2.default, {
	        title: "Contact Us",
	        desc: "We want to hear from you"
	      }),
	      _react2.default.createElement(
	        _container2.default,
	        null,
	        _react2.default.createElement(
	          "h1",
	          { style: { paddingTop: "50px" } },
	          "Drop us a line. We'd love to chat!"
	        )
	      ),
	      _react2.default.createElement(
	        _container2.default,
	        { customClassName: "page-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "page-sixth-contact" },
	          _react2.default.createElement(
	            "div",
	            { className: "contact-form" },
	            _react2.default.createElement(
	              "form",
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "half" },
	                  _react2.default.createElement("input", { onChange: this.onChange, type: "text", value: this.state.name, name: "name", placeholder: "Name" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "half" },
	                  _react2.default.createElement("input", { onChange: this.onChange, type: "email", value: this.state.email, name: "email", placeholder: "E-mail" })
	                )
	              ),
	              _react2.default.createElement("input", { onChange: this.onChange, type: "text", value: this.state.subject, name: "subject", placeholder: "Subject" }),
	              _react2.default.createElement("textarea", { onChange: this.onChange, name: "message", value: this.state.message, placeholder: "Message" }),
	              _react2.default.createElement("input", { onClick: this.onSubmit, type: "button", className: "button-purple", value: "Send" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "page-third" },
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Contact Info"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              "E-mail: info@webbholding.me"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              "Website: www.webbholding.me"
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-5187fe6ea2ee492adf22.js